import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledFormsTemplatesListItem = styled(StyledFlex)`
   width: 100%;
   height: 100%;
`;
